export const MATRIX_CHANGE_STARTED = 'MATRIX_CHANGE_STARTED';
export const MATRIX_CHANGE_SUCCEED = 'MATRIX_CHANGE_SUCCEED';
export const MATRIX_CHANGE_ERROR = 'MATRIX_CHANGE_ERROR';
export const MATRIX_CREATE_STARTED = 'MATRIX_CREATE_STARTED';
export const MATRIX_CREATE_SUCCEED = 'MATRIX_CREATE_SUCCEED';
export const MATRIX_CREATE_ERROR = 'MATRIX_CREATE_ERROR';
export const PROFILE_PAGE_VIEW = 'PROFILE_PAGE_VIEW';
export const PROFILE_SIGN_OUT = 'PROFILE_SIGN_OUT';
export const PROFILE_SESSION_EXPIRED = 'PROFILE_SESSION_EXPIRED';
export const PROFILE_ERROR = 'PROFILE_ERROR';
export const EMPLOYEE_ADD_STARTED = 'EMPLOYEE_ADD_STARTED';
export const EMPLOYEE_ADD_SUCCEED = 'EMPLOYEE_ADD_SUCCEED';
export const EMPLOYEE_ADD_ERROR = 'EMPLOYEE_ADD_ERROR';
export const EMPLOYEE_REMOVED = 'EMPLOYEE_REMOVED';
export const EMPLOYEE_RESTORED = 'EMPLOYEE_RESTORED';
export const ESIGN_REVOKE_STARTED = 'ESIGN_REVOKE_STARTED';
export const ESIGN_REVOKE_WRONG_PASSWORD = 'ESIGN_REVOKE_WRONG_PASSWORD';
export const ESIGN_REVOKE_ERROR = 'ESIGN_REVOKE_ERROR';
export const ESIGN_REVOKE_REJECT = 'ESIGN_REVOKE_REJECT';
export const ESIGN_PASSWORD_RESET = 'ESIGN_PASSWORD_RESET';
export const ESIGN_REVOKE_SUCCEED = 'ESIGN_REVOKE_SUCCEED';
export const ESIGN_REVOKE_ESIGN_BLOCKED = 'ESIGN_REVOKE_ESIGN_BLOCKED';
